<template>
  <div
    class="mydialog"
    :style="{ width: width + 'px' }"
    v-if="$store.state.isShow"
    id="mydialog"
  >
    <div class="dialog-header">
      <span>{{ title }}</span>
      <i class="el-icon-close" @click="close"></i>
      <i
        class="el-icon-minus"
        @click="isShowContent = !isShowContent"
        v-if="isShowContent"
      ></i>
      <i
        class="icon-zdh"
        v-if="!isShowContent"
        @click="isShowContent = !isShowContent"
      ></i>
    </div>
    <div class="dialog-content" v-show="isShowContent">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShowContent: true,
      isShow: true,
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "",
    },
  },
  methods: {
    close() {
      this.$store.state.isShow = false;
      //this.$emit('')
    },
  },
};
</script>
<style lang="scss" scoped>
.mydialog {
  //   position: fixed;
  //   top: 80px;
  //   left: 300px;
  margin: 30px 0 0 40px;
  z-index: 999;
  background: #24313d;
  overflow: hidden;
  //transition: left 0.3s;
  .dialog-header {
    height: 35px;
    background: #3b4e5c;
    color: #00e3e4;
    font-size: 14px;
    padding: 0 10px 0 15px;
    line-height: 35px;

    i {
      float: right;
      color: #fff;
      margin-top: 10px;
      cursor: pointer;
      margin-left: 10px;
    }
    .icon-zdh {
      background: url(../../assets/icon/zdh.png);
      background-size: cover;
      width: 14px;
      height: 14px;
    }
  }

  .dialog-content {
    margin: 15px;
    font-size: 14px;
  }
}
</style>
